import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { ObligacionDTO, TipoObligacionDTO } from "../interfaces/Deudas/DeudasDTO";
const localBack: string = process.env.REACT_APP_BACK_FINANCIERO || '';
const APICATALOGO: string = '/api/FondoRotativos';

export default class FondoRotativoService {

    async GetObligaciones(token: any, estado?: string, page: number = 1, pageSize: number = 10): Promise<ResponceApi<ObligacionDTO>> {
        const response1: AxiosResponse<ResponceApi<ObligacionDTO>> = await axios.get(localBack + APICATALOGO + '/Obligaciones',
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    ...(estado ? { estado } : {}),
                    page,
                    pageSize
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetObligacionById(id: number, token: any): Promise<ResponceApi<ObligacionDTO>> {
        const response1: AxiosResponse<ResponceApi<ObligacionDTO>> = await axios.get(localBack + APICATALOGO + '/ObligacionById/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetTiposObligaciones(token: any): Promise<ResponceApi<TipoObligacionDTO>> {
        const response1: AxiosResponse<ResponceApi<TipoObligacionDTO>> = await axios.get(localBack + APICATALOGO + '/TiposObligacion',
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async IngresarObligacion(obligacion: ObligacionDTO, token: any): Promise<ResponceApi<ObligacionDTO>> {
        const response1: AxiosResponse<ResponceApi<ObligacionDTO>> = await axios.post(localBack + APICATALOGO + '/IngresarObligacion',
            obligacion,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async ActualizarObligacion(id: number, obligacion: ObligacionDTO, token: any): Promise<ResponceApi<ObligacionDTO>> {
        const response1: AxiosResponse<ResponceApi<ObligacionDTO>> = await axios.put(localBack + APICATALOGO + '/ActualizarObligacion/' + id,
            obligacion,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
        //console.log(response1.data);        
        return response1.data;
    }

    //filtros

    async GetObligacionesExcel(token: any, estado?: string) {
        return await axios.get(
            `${localBack}${APICATALOGO}/ObligacionesExcel`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                },
                params: estado ? { estado } : {},
                responseType: "arraybuffer"
            }
        );
    }

    async GetObligacionesPdf(token: any, estado?: string) {

        return await axios.get(
            `${localBack}${APICATALOGO}/ObligacionesPdf`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/pdf, application/octet-stream, application/json, text/plain, text/html",
                },
                params: estado ? { estado } : {},
                responseType: "arraybuffer"
            }
        );
    }

    async GetObligacionesByIdPersona(id: number, token: any, page: number = 1, pageSize: number = 10): Promise<ResponceApi<ObligacionDTO>> {
        const response = await axios.get<ResponceApi<ObligacionDTO>>(
            `${localBack}${APICATALOGO}/ObligacionesPorIdpersona/` + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    page,
                    pageSize
                }
            }
        );
        return response.data;
    }

    async GetObligacionesByTipo(id: number, token: any, page: number = 1, pageSize: number = 10): Promise<ResponceApi<ObligacionDTO>> {
        const response = await axios.get<ResponceApi<ObligacionDTO>>(
            `${localBack}${APICATALOGO}/ObligacionesPorTipoDeuda/` + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    page,
                    pageSize
                }
            }
        );
        return response.data;
    }

}